import { defineComponent as n, openBlock as r, createBlock as a, unref as v, mergeProps as m, withCtx as l, createElementVNode as p } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconHdmi",
  __name: "IconHdmi",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (d, e) => (r(), a(v(i), m(t, { "view-box": "0 0 24 24" }), {
      default: l(() => [...e[0] || (e[0] = [
        p("path", {
          "fill-rule": "evenodd",
          d: "M5.25 3.5A1.25 1.25 0 0 1 6.5 2.25h11a1.25 1.25 0 0 1 1.25 1.25v4.775a1.25 1.25 0 0 1 1 1.225v6a3.25 3.25 0 0 1-3.25 3.25h-3.75V21a.75.75 0 0 1-1.5 0v-2.25H7.5a3.25 3.25 0 0 1-3.25-3.25v-6a1.25 1.25 0 0 1 1-1.225V3.5M16.5 17.25a1.75 1.75 0 0 0 1.75-1.75V9.75H5.75v5.75a1.75 1.75 0 0 0 1.75 1.75h9M9.75 3.75h4.5v4.5h-4.5v-4.5m6 0v4.5h1.5v-4.5h-1.5m-7.5 0h-1.5v4.5h1.5v-4.5",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
